export enum SPECS {
  ENABLE_LOST_BUSINESS_EMAIL = 'specs.stores.EnableLostBusinessEmail',
  SUBSCRIPTION_PLANS = 'specs.stores.ProductSubscriptionsSF',
  SUPPORT_PREMIUM_FEATURES_STOREFRONT = 'specs.stores.SupportPremiumFeaturesStoreFront',
  SHARE_VIA_WHATSAPP = 'specs.stores.ProductPageShareViaWhatsapp',
}
